/**
 * The subscription-tier wire vocabulary, shared by `Plan` (rules) and
 * `descriptors` (display copy) so neither has to import the other.
 *
 * Wire values are frozen — the backend sends exactly these strings and they
 * cannot be renamed (see docs/domain-refactor-roadmap.md, "Frozen facts").
 */
export const SUBSCRIPTION_TIERS = [
  "pre_onboarding",
  "free_tier",
  "subscriber_business",
  "subscriber_enterprise",
  "inhouse_counsel",
] as const;

/** The five wire values the backend sends. Frozen — do not rename. */
export type SubscriptionTier = (typeof SUBSCRIPTION_TIERS)[number];

/** Ordering for a concrete tier: both free tiers 0, then the three paid ranks. */
export type TierRank = 0 | 1 | 2 | 3;
